export default "__VITE_ASSET__3ab0c301__"